"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SineSignInOutData = void 0;
var runtypes_1 = require("runtypes");
var runtypeImplementing_1 = require("../../../util/runtypeImplementing");
var Data_1 = require("./Data");
// A Sign in / out event.
exports.SineSignInOutData = (0, runtypeImplementing_1.runtypeImplementing)(Data_1.Data)((0, runtypes_1.Record)({
    type: (0, runtypes_1.Literal)("sineSignInOut"),
    inOut: (0, runtypes_1.Union)((0, runtypes_1.Literal)("in"), (0, runtypes_1.Literal)("out")),
}));
//# sourceMappingURL=SineSignInOutData.js.map